<template>
    <div class="facebook-login-button">
        <button
            class="btn btn-facebook"
            @click.prevent="onClick"
        >
            <img src="/img/icons/facebook-logo.svg" alt="Facebook">
            <span>{{ lang.labels.facebook|capitalize }}</span>
        </button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            facebook_data: {},
        }
    },

    computed: {
        lang() {
            return this.$root.lang.login_form
        },
    },

    methods: {
        login() {
            isLoading()

            axios.post('/api/facebook-login', this.facebook_data)
                .then(({data}) => {
                    stopLoading()

                    this.$emit('signedin', data)
                })
                .catch(response => {
                    stopLoading()

                    window.events.$emit('hideModal', { name: 'login' })

                    alert('Errore nel login tramite Facebook')
                })
        },

        onClick () {
            FB.login(response => {
                console.log(response)
                if (response.authResponse) {
                    this.facebook_data = { token: response.authResponse.accessToken }

                    this.login()
                } else {
                    alert('Il login Facebook ha avuto un problema. Prova con un altro metodo di login!');
                }
            }, {scope: 'email,public_profile'})
            return false
        },
    },
}
</script>